import { AppTheme } from '@lib/theme';
import { NavigationProp } from '@react-navigation/native';
import Constants from 'expo-constants';
import { ForwardedDrawerScreenProps } from "react-navigation-props-mapper/lib/typescript/types";

// ⚠️: Environment variables must be statically referenced as a property of process.env using
// the JavaScript's dot notation for it to be inlined (i.e. process.env.EXPO_PUBLIC_API_URL).
// Expressions such as `process.env['EXPO_PUBLIC_API_URL']` or `const {EXPO_PUBLIC_API_URL} = process.env`
// will not work.
export const EXPO_PUBLIC_PAYBOOKS_API_BASE = process.env.EXPO_PUBLIC_PAYBOOKS_API_BASE;

export const EXPO_PUBLIC_PAYBOOKS_MIXPANEL_PROXY_DOMAIN = process.env.EXPO_PUBLIC_PAYBOOKS_MIXPANEL_PROXY_DOMAIN;
export const EXPO_PUBLIC_PAYBOOKS_MIXPANEL_PROJECT_TOKEN = process.env.EXPO_PUBLIC_PAYBOOKS_MIXPANEL_PROJECT_TOKEN;

export const EXPO_PUBLIC_PAYBOOKS_REVENUECAT_CLIENT_WEB_APP_API_KEY = process.env.EXPO_PUBLIC_PAYBOOKS_REVENUECAT_CLIENT_WEB_APP_API_KEY;
export const EXPO_PUBLIC_PAYBOOKS_REVENUECAT_CLIENT_ANDROID_APP_API_KEY = process.env.EXPO_PUBLIC_PAYBOOKS_REVENUECAT_CLIENT_ANDROID_APP_API_KEY;

export const EXPO_PUBLIC_PAYBOOKS_GOOGLE_WEB_CLIENT_ID = process.env.EXPO_PUBLIC_PAYBOOKS_GOOGLE_WEB_CLIENT_ID;

export const APP_VERSION = Constants?.expoConfig?.version;

// export const STATE_CANCEL = -1;
// export const STATE_READY = 0;
// export const STATE_LOADING = 1;
// export const STATE_DONE = 2;
// export const STATE_ERROR = 3;

export enum STATE {
  CANCEL = -1,
  READY = 0,
  LOADING = 1,
  DONE = 2,
  ERROR = 3,
}

export const PAGE_SIZE = 50;

export const TermsOfUseUrl = 'https://paybooks.app/pages/terms-conditions';

export type PageProps<T = any> = {
  data?: T;
  onDone?: (data: T) => void;
  navigation?: NavigationProp<RootParamList>;
  theme?: AppTheme;
};

export type RootParamList = {
  TestScreen: undefined;
  SplashScreen: undefined,
  OnboardingSlider: undefined,
  EmailLogin?: PageProps;
  OtpLogin?: PageProps;
  Subscriptions?: PageProps;
  Dashboard?: PageProps;
  ChartOfAccounts?: PageProps;
  BankAccountCreate?: PageProps;
  AccountCreate?: PageProps;
  Taxes?: PageProps;
  NonInventoryProductServiceCreate?: PageProps;
  InventoryProductCreate?: PageProps;
  ProductsServices?: PageProps;
  Documents?: PageProps;
  EstimateCreate?: PageProps;
  DocumentView?: PageProps;
  BillCreate?: PageProps;
  Contacts?: PageProps;
  ContactView?: PageProps;
  ContactCreate?: PageProps;
  StatementIncome?: PageProps;
  StatementBalanceSheet?: PageProps;
  BusinessView?: PageProps;
  BusinessCreate?: PageProps;

  More?: PageProps;
};

export type ForwardedPageProps = ForwardedDrawerScreenProps<RootParamList, keyof RootParamList> & PageProps;

export const linking = {
  prefixes: ["https://portal.paybooks.app", "app://"],
  screens: {
    SplashScreen: "SplashScreen",
    OnboardingSlider: "OnboardingSlider",
    TestScreen: "TestScreen",
    EmailLogin: "EmailLogin",
    OtpLogin: "OtpLogin",
    Subscriptions: "Subscriptions",
    Dashboard: "Dashboard",
    ChartOfAccounts: "ChartOfAccounts",
    AccountCreate: "AccountCreate",
    Taxes: "Taxes",
    InventoryProductCreate: "InventoryProductCreate",
    NonInventoryProductServiceCreate: "NonInventoryProductServiceCreate",
    ProductsServices: "ProductsServices",
    Documents: "Documents",
    EstimateCreate: "EstimateCreate",
    DocumentView: "DocumentView",
    BillCreate: "BillCreate",
    Contacts: "Contacts",
    ContactView: "ContactView",
    ContactCreate: "ContactCreate",
    StatementIncome: "StatementIncome",
    StatementBalanceSheet: "StatementBalanceSheet",
    BusinessView: "BusinessView",
    BusinessCreate: "BusinessCreate",
    More: "More",
  },
};

export interface APIData {
  // Common HTTP Methods (Verbs) 
  //   GET: Used to retrieve or request data from a server. It is safe, meaning it does not change the state of the resource.
  //   POST: Used to submit data to be processed to a specified resource, often for creating new resources.
  //   PUT: Used to update or replace an entire resource at a specified location.
  //   PATCH: Used to apply partial modifications to a resource.
  //   DELETE: Used to remove a specified resource from the server
  operation?: "GET" | "POST" | "PUT" | "PATH" | "DELETE";
  state?: STATE;
  data?: Array<Object> | Object | any;
  message?: string;
  query?: {};
}

export const initialValue: APIData = {
  operation: "GET",
  state: STATE.READY,
};

export type Auth = ({ token: string; }) | null;